export const GET_CUSTOMER_STARTED = 'GET_CUSTOMER_STARTED';
export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS';
export const GET_CUSTOMER_FAILED = 'GET_CUSTOMER_FAILED';
export const GET_ECOSYSTEM_STARTED = 'GET_ECOSYSTEM_STARTED';
export const GET_ECOSYSTEM_SUCCESS = 'GET_ECOSYSTEM_SUCCESS';
export const GET_ECOSYSTEM_FAILED = 'GET_ECOSYSTEM_FAILED';
export const TOKEN_VERIFICATION_FAILED = 'TOKEN_VERIFICATION_FAILED';
